<!--Title-->
<div class="d-flex justify-content-between align-items-center">
    <h3>{{'_General_Permission_Groups_Text_' | translate }}</h3>
    
    <!-- Add Permission Button-->
    <button *ngIf="userPermissionList?.includes(15)" type="button" class="btn btn-primary"
        (click)="gotoPermissionAdd()">
        {{'_Permission_Grid_Add_Permission_Group_Text_' | translate }}
    </button>
</div>

<div class="cc-content-wrapper">

    <!--Action Panel-->
    <div class="cc-action-panel row">
        <!--Search-->
        <div class="cc-search with-close">
            <input id="userSearchText" type="text" [(ngModel)]="searchText" class="form-control" placeholder="{{'_General_Search_Text_' | translate }}" 
            (keyup.enter)="searchPermissionGroups()"/>
            <button id="permissionGridSearch" type="button" class="cc-search-btn"
                (click)="searchPermissionGroups()"><span class="fas fa-search"></span></button>
            <button type="button" [ngClass]="{'show-btn': searchText!=''}" (click)="clearSarchPermissionGroups()"
                class="cc-close-btn"><span class="fas fa-times"></span></button>
        </div>
    </div>

    <div>
        <kendo-grid [data]="gridData" [pageSize]="pageSize" [skip]="skip" [pageable]="true" [sortable]="true"
            scrollable="scrollable" (sortChange)="onSortChange($event)" (pageChange)="onPageChange($event)">
        <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
            <kendo-grid-column field="permissionUserGroupName" title="{{'_Permission_Edit_Permissions_Group_Name_Text_' | translate }}" [sortable]="true"
                [headerStyle]="{'font-weight' : 'bold'}">
            </kendo-grid-column>

            <kendo-grid-column field="notificationGroup" title="{{'_Permission_Edit_Notification_Group_Text_' | translate }}" 
                class="d-flex" [sortable]="false" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="cell-items-center">
                    <input type="checkbox" class="cc-filter-checkbox" kendoCheckBox
                        [checked]="dataItem.notificationGroup" [disabled]="true">
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="220" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="cell-items-center">
                    <button *ngIf="dataItem.isEditable && (userPermissionList?.includes(16))" class="cc-icon-btn"
                        title="{{'_General_Button_Edit_Text_' | translate }}" (click)="onPermissionGroupEdit(dataItem)"><span class="fas fa-pen"></span></button>
                        <button *ngIf="dataItem.isEditable && (userPermissionList?.includes(17))" class="cc-icon-btn"
                            title="{{'_General_Button_Delete_Text_' | translate }}" (click)="onDelete(dataItem)"><span
                                class="fas fa-trash"></span></button>
                    <button *ngIf="dataItem.isEditable && !(userPermissionList?.includes(16))" class="cc-icon-btn"
                        title="{{'_General_View_Text_' | translate }}" (click)="onPermissionGroupView(dataItem)"><span class="fas fa-eye"></span></button>
                    <button *ngIf="!dataItem.isEditable && (userPermissionList?.includes(14))" class="cc-icon-btn"
                        title="{{'_General_View_Text_' | translate }}" (click)="onPermissionGroupView(dataItem)"><span class="fas fa-eye"></span></button>
                    </div>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
    </div>
</div>
<app-modalpopup header="{{permissionGroupDeleteHeader}}"
    [(dialogOpened)]="showCanDeletePermissionGroupPopup" [isInfo]="false"
    actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}"
    actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}"
    message="{{groupDeletePopupContent}}"
    (submitted)="performDelete(1)" (cancelled)="onCloseConfimationPopup()">
</app-modalpopup>
<app-modalpopup header="{{permissionGroupDeleteHeader}}" [(dialogOpened)]="showCannotDeletePermissionGroupPopup"
    [isInfo]="true" 
    actionYesLabel="{{'_General_Button_Ok_Text_' | translate}}" message="{{groupDeletePopupContent}}"
    (cancelled)="onCloseConfimationPopup()"   (submitted)="onCloseConfimationPopup()">
</app-modalpopup>
